import React from 'react';

export interface WebsitePageShellProps {
  children: React.ReactNode;
  className?: string;
  /** Coluna de leitura estreita (ex.: post do blog, retorno de doação) */
  narrow?: boolean;
  /**
   * Coluna média (079) — telas com formulário/abas ou texto legal (Minha
   * Conta, Termos/Privacidade): mais espaço que `narrow` sem ir até a
   * largura cheia do site (`max-w-7xl` do `WebsiteLayout`), que fica larga
   * demais pra conteúdo de leitura/formulário.
   */
  medium?: boolean;
}

export const WebsitePageShell: React.FC<WebsitePageShellProps> = ({
  children,
  className = '',
  narrow = false,
  medium = false,
}) => (
  <div
    // Marco de "página pública montada" — scripts/prerender.mjs espera por
    // este atributo antes de capturar o HTML da rota (evita salvar a tela
    // ainda em branco). Não afeta nada em runtime normal.
    data-prerender-ready="true"
    className={`lp-page-shell ${narrow ? 'max-w-3xl mx-auto w-full' : ''} ${medium ? 'max-w-5xl mx-auto w-full' : ''} ${className}`.trim()}
  >
    {children}
  </div>
);
